import { ChartTooltipLabelShape } from '@/components/common/charts/ChartTooltip';
import {
    Circle,
    Diamond,
    ShapeProps,
    Square,
} from '@/components/common/charts/shapes/shapes';
import { TransactionsChartDatum } from '@common/react/cashflow';
import styleguide from '@common/styleguide';
import { DateRange } from '@common/types';
import { dt, getRangeUnit } from '@common/util/dateTime';
import { TickRange, ValueSeries } from '@common/valueSeries';
import { app } from '@common/zapatos';
import { FC } from 'react';

export interface CashflowChartProps {
    width: number;
    height: number;
    valueSeries: ValueSeries<TransactionsChartDatum>;
    range: TickRange;
    selectedSupercategories: app.supercategory[];
}

export const SUPERCATEGORY_CONFIG: Record<
    app.supercategory,
    {
        color: string;
        label: string;
        shape: ChartTooltipLabelShape;
        shapeComponent: FC<ShapeProps>;
    }
> = {
    INCOME: {
        color: '#63BE5B',
        label: 'Income',
        shape: 'square',
        shapeComponent: Square,
    },
    SPENDING: {
        color: '#FF8484',
        label: 'Spending',
        shape: 'circle',
        shapeComponent: Circle,
    },
    SAVING_INVESTING: {
        color: '#5DBBFF',
        label: 'Saving & Investing',
        shape: 'diamond',
        shapeComponent: Diamond,
    },
    TRANSFERS: {
        color: styleguide.colors.grayLight,
        label: 'Transfers',
        shape: 'circle',
        shapeComponent: Circle,
    },
};

export const AVERAGE_LABEL_COLOR = '#A3A3A3';
export const AVERAGE_CHART_COLOR = '#D1D1D1';

export const shouldShowAverages = (
    selectedSupercategories: app.supercategory[]
) => selectedSupercategories.length === 1;

export const getArrowVisibility = (
    dateRange: DateRange,
    isAllTimeDateRange: boolean
) => {
    const unit = getRangeUnit(dateRange);

    if (isAllTimeDateRange) {
        return { showNext: false, showPrevious: false };
    } else if (unit === 'custom') {
        return { showNext: true, showPrevious: true };
    } else {
        const nextStartDate = dt(dateRange.startDate)
            .add(1, unit)
            .startOf(unit);

        return {
            showNext: nextStartDate.isBefore(dt().endOf(unit)),
            showPrevious: true,
        };
    }
};
